// eslint-disable-next-line
import { h, Component } from "preact";
import SeButton from '../SeButton';

import styles from './index.scss';

class Checkout extends Component {
    renderCheckoutButtons() {
        const {
            isTradeUpsCart,
            isValidCart,
            isEcommerceSite,
            shoppingCartUrl,
            expressCheckoutEnabled,
            expressCheckout,
            keyword_Checkout,
            standardCheckout,
            viewShoppingCart,
            checkoutButton,
            siteId,
        } = this.props;

        if (isTradeUpsCart || !isValidCart || !isEcommerceSite) {
            return (
                <SeButton
                    extraClass={styles.unusualCheckout}
                    secondary={true}
                    size="big"
                    block={true}
                    isLink={true}
                    externalPath={shoppingCartUrl}
                >
                    {viewShoppingCart}
                </SeButton>
            );
        }

        if (expressCheckoutEnabled) {
            return (
                <div>
                    <SeButton
                        extraClass={styles.unusualCheckout}
                        secondary={false}
                        size="big"
                        block={true}
                        onClick={this.sendRequest('express')}
                    >
                        {expressCheckout}
                    </SeButton>
                    <div className={styles.standartCheckout}>
                        <a
                            href={`/rest/model/atg/commerce/order/purchase/CartModifierActor/standardCheckout?pushSite=${siteId}&successUrl=${
                                checkoutButton.successUrl
                            }&errorUrl=${checkoutButton.errorUrl}`}
                            className={styles.link}
                        >
                            {standardCheckout}
                        </a>
                    </div>
                </div>
            );
        }

        return (
            <SeButton
                extraClass={styles.unusualCheckout}
                secondary={false}
                size="big"
                block={true}
                onClick={this.sendRequest('standart')}
            >
                {keyword_Checkout}
            </SeButton>
        );
    }

    sendRequest = type => () => {
        const { checkoutButton, expressCheckoutButton, siteId } = this.props;

        switch (type) {
            case 'standart':
                window.location = `/rest/model/atg/commerce/order/purchase/CartModifierActor/standardCheckout?pushSite=${siteId}&successUrl=${
                    checkoutButton.successUrl
                }&errorUrl=${checkoutButton.errorUrl}`;
                break;
            case 'express':
                window.location = `/rest/model/atg/commerce/order/purchase/CartModifierActor/expressCheckout?pushSite=${siteId}&successUrl=${
                    expressCheckoutButton.successUrl
                }&errorUrl=${expressCheckoutButton.errorUrl}`;
                break;
            default:
                console.log('default');
        }
    };

    render() {
        return <div>{this.renderCheckoutButtons()}</div>;
    }
}

export default Checkout;
